export default "__VITE_ASSET__Cjf8gB2C__"